export default __webpack_public_path__ + "static/sticker-obsessed-3688782c5eded210511fa287573298e2.svg";